import { render, staticRenderFns } from "./messageTemplateCategoryList.vue?vue&type=template&id=89ab7422"
import script from "./messageTemplateCategoryList.vue?vue&type=script&lang=js"
export * from "./messageTemplateCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports